"use strict"

angular.module("vendor")
.service("ShippingRateService", function(
    $resource, FlashBag, $state, gettextCatalog, appConfig,
    SHIPPING_RATE_METHOD_PER_ORDER, SHIPPING_RATE_METHOD_PER_AMOUNT, SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
) {
    var resource = $resource(appConfig.API_SERVER + "/shipping-rates/:id/", {
        id: "@id"
    }, {
        get: {
            method: "GET", isArray: false
        },
        query: {
            method: 'GET', isArray: true
        },
        create: {
            method: "POST"
        },
        update: {
            method: "PATCH"
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.get = function(id) {
        var params = {
            id: id
        };
        return resource.get(params,
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };

    this.query = function() {
        return resource.query();
    };

    this.create = function(data) {
        return (new resource(data)).$save();
    };

    this.update = function(instance) {
        if (instance.id) {
            return instance.$update();
        }
        else {
            throw "NO_UPDATE_FOR_CREATION";
        }
    };

    this.delete = function(id) {
        return resource.delete({id: id}).$promise;
    };

    this.getShippingRateMethodTranslations = function(code) {
        var methods = {};
        methods[SHIPPING_RATE_METHOD_PER_ORDER] = gettextCatalog.getString("Per Order");
        methods[SHIPPING_RATE_METHOD_PER_AMOUNT] = gettextCatalog.getString("Per Amount");
        methods[SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT] = gettextCatalog.getString("Per Region and Weight");
        return methods;
    }

    this.getShippingRateMethodTranslationByCode = function(code) {
        var methods = this.getShippingRateMethodTranslations();
        if (methods.hasOwnProperty(code)) {
            return methods[code];
        }
        return "";
    }

    this.getShippingRateMethod = function() {
        return [
            {code: SHIPPING_RATE_METHOD_PER_ORDER, name: this.getShippingRateMethodTranslationByCode(SHIPPING_RATE_METHOD_PER_ORDER)},
            {code: SHIPPING_RATE_METHOD_PER_AMOUNT, name: this.getShippingRateMethodTranslationByCode(SHIPPING_RATE_METHOD_PER_AMOUNT)},
            {code: SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT, name: this.getShippingRateMethodTranslationByCode(SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT)}
        ];
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/shipping-rate/shipping-rate.service.js
// module id = 887
// module chunks = 0